export default {"src":"/_next/static/media/@twitter.7f149657.svg","height":30,"width":30};